var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_373_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74239 23.0907C10.948 24.3672 13.5425 24.798 16.0423 24.3028C18.542 23.8076 20.7764 22.4202 22.3288 20.3993C23.8812 18.3784 24.6457 15.8619 24.4797 13.319C24.3137 10.776 23.2286 8.38027 21.4266 6.57832C19.6247 4.77637 17.2289 3.69124 14.6859 3.52524C12.143 3.35924 9.62651 4.12371 7.60559 5.67611C5.58467 7.22851 4.19729 9.46288 3.70212 11.9626C3.20694 14.4624 3.63776 17.057 4.91426 19.2625L3.54598 23.3477C3.49456 23.5019 3.4871 23.6673 3.52443 23.8255C3.56176 23.9837 3.6424 24.1283 3.75732 24.2432C3.87224 24.3581 4.01689 24.4388 4.17506 24.4761C4.33324 24.5134 4.49868 24.506 4.65285 24.4546L8.74239 23.0907Z",
    stroke: "#141414",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_373_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircle);
export default __webpack_public_path__ + "static/media/ChatCircle.0e3915d77e34abba33e036ae1e2bd6c4.svg";
export { ForwardRef as ReactComponent };